import './_plugins.js';
import ViewContainer from './ViewContainer.js';

(function () {
    window.ViewContainer = new ViewContainer();
    window.ViewContainer.initialize();
})();

